import Common from './Common';
import LoraWan from './LoraWan';
import MoT from './MoT';

const ActionsItems = {
  Common,
  LoraWan,
  MoT,
};

export default ActionsItems;
